"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-15fcba83"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "header-text" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = {
    key: 0,
    class: "flex-column flex-gap"
};
const _hoisted_4 = { class: "input-group column p-0" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "input-group-addon" }, "ラベル", -1 /* HOISTED */));
const _hoisted_7 = { class: "input-group column p-0" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "input-group-addon" }, "から", -1 /* HOISTED */));
const _hoisted_10 = { class: "input-group column p-0" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "input-group-addon" }, "まで", -1 /* HOISTED */));
const _hoisted_13 = { class: "flex-column p-0" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", {
    class: "divider text-center",
    "data-content": "メモ"
}, null, -1 /* HOISTED */));
const _hoisted_15 = { class: "input-group mt-2" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const common_1 = require("../../common/common");
const sectionRequest_1 = require("../../requests/sectionRequest");
const shift_1 = require("../../js/shift");
const errors_1 = __importDefault(require("../../js/errors"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionEditModal',
    props: {
        userId: {
            type: Number,
            required: true,
        },
        branchId: {
            type: Number,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        }
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const isLoading = (0, vue_3.ref)(false);
        const isVisible = (0, vue_3.ref)(false);
        const isRepeatSlot = (0, vue_3.ref)(false);
        const section = (0, vue_3.ref)(null);
        function openModal(sectionData, isRepeat) {
            section.value = sectionData;
            isRepeatSlot.value = isRepeat;
            isVisible.value = true;
        }
        __expose({
            openModal,
        });
        function closeModal() {
            isVisible.value = false;
        }
        async function updateSection() {
            if (isLoading.value || !section.value) {
                return;
            }
            // Warning for repeat shifts
            if (isRepeatSlot.value && !confirm("関連するリピートシフト全てに反映されますが、よろしいですか？")) {
                return;
            }
            isLoading.value = true;
            const data = {
                id: section.value.id,
                from: section.value.fromTime,
                to: section.value.toTime,
                purpose: section.value.purpose,
                roleID: section.value.roleId,
                color: section.value.color,
                date: section.value.date,
                type: section.value.type,
                locked: section.value.locked,
                rest: section.value.rest,
                restSection: section.value.type === 4,
                sendEmail: false,
                memo: section.value.memo,
                edited: true,
            };
            try {
                const result = await (0, sectionRequest_1.updateSectionPutRequest)(props.userId, props.branchId, data);
                if (!result.success) {
                    throw new Error();
                }
                (0, shift_1.updateSectionMap)(result.slot);
            }
            catch (err) {
                (0, shift_1.openAlertModal)(errors_1.default.SECTION.UPDATE);
            }
            finally {
                isLoading.value = false;
                closeModal();
            }
        }
        const dateLabel = (0, vue_3.computed)(() => {
            if (!section.value) {
                return "";
            }
            return (0, common_1.jpDateString)(new Date(section.value.date), timeZones_1.default.ASIA_TOKYO, true);
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? "loading" : "";
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    "has-title-divider": true,
                    "has-footer-divider": false
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("span", _hoisted_1, (0, vue_2.toDisplayString)(dateLabel.value), 1 /* TEXT */)
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (section.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((section.value.purpose) = $event)),
                                            class: "form-input",
                                            type: "text",
                                            disabled: !__props.canEdit,
                                            placeholder: "任意 例：レジ、清掃"
                                        }, null, 8 /* PROPS */, _hoisted_5), [
                                            [vue_2.vModelText, section.value.purpose]
                                        ]),
                                        _hoisted_6
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((section.value.fromTime) = $event)),
                                            class: "form-input",
                                            type: "text",
                                            disabled: !__props.canEdit,
                                            placeholder: "10, 10:00, 1000"
                                        }, null, 8 /* PROPS */, _hoisted_8), [
                                            [vue_2.vModelText, section.value.fromTime]
                                        ]),
                                        _hoisted_9
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((section.value.toTime) = $event)),
                                            class: "form-input",
                                            type: "text",
                                            disabled: !__props.canEdit,
                                            placeholder: "18, 18:00, 1800"
                                        }, null, 8 /* PROPS */, _hoisted_11), [
                                            [vue_2.vModelText, section.value.toTime]
                                        ]),
                                        _hoisted_12
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                        _hoisted_14,
                                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((section.value.memo) = $event)),
                                                class: "form-input font-sm",
                                                rows: "4",
                                                placeholder: "メモ"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, section.value.memo]
                                            ])
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("button", {
                            class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", loadingClass.value]),
                            onClick: updateSection
                        }, "編集", 2 /* CLASS */)
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
